import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import store from './stores/redux';
import config from './config';
import App from './App';
import router from './configRouter';
import ChildrenContext from './components/ChildrenContext';
import NotFoundPage from './components/pages/errors/NotFoundPage';
import ServerErrorPage from './components/pages/errors/ServerErrorPage';
import AuthorisationErrorPage from './components/pages/errors/AuthorisationErrorPage';
import SessionActions from './actions/SessionActions';
import UserInfoActions from './actions/UserInfoActions';
import PaceProgressActions from './actions/PaceProgressActions';
import GlobalLoading from './components/GlobalLoading';

import { push, replace, goBack } from 'utils/navigation';
import RouterSync from "./compat/RouterSync";
export const history = { push, replace, goBack };

PaceProgressActions.init();

const appElem = document.getElementById('app');
const root = createRoot(appElem);

const toV6Params = (params = {}) => {
    const { component: Component, element, ...rest } = params;
    return { ...rest, element: element || (Component ? <Component /> : null) };
};

const renderApp = () => {
    root.render(
        <Provider store={store}>
            <ChildrenContext>
                <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <RouterSync />
                    <Routes>
                        <Route path={config.defaultRoute} element={<App />}>
                            {router.map((item, i) =>
                                i === 0 ? (
                                    <Route key={item.key} index {...toV6Params(item.params)} />
                                ) : (
                                    <Route key={item.key} {...toV6Params(item.params)} />
                                )
                            )}
                        </Route>

                        <Route path={`${config.defaultRoute}500`} element={<ServerErrorPage />} />
                        <Route path={`${config.defaultRoute}401`} element={<AuthorisationErrorPage />} />
                        <Route path={`${config.defaultRoute}404`} element={<NotFoundPage />} />
                        <Route path="*" element={<Navigate to={`${config.defaultRoute}404`} replace />} />
                    </Routes>
                </BrowserRouter>
            </ChildrenContext>
        </Provider>
    );
};

SessionActions.authorize(
    () => {
        UserInfoActions.loadInfo().then(renderApp);
    },
    () => {
        root.render(<GlobalLoading />);
    }
);
